import { Toasts } from '@/Components/Toast/Toast';
import { useLocalization } from '@/Hooks';
import { shippingLabelModalActions, shippingLabelModalSelectors } from '@/ModalWindows/ShippingLabelModal/services';
import { ShippingLabelStep } from '@/ModalWindows/ShippingLabelModal/Types';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { orderAutomatizationActions, orderAutomatizationAsyncActions } from '../services/reducer';
import { unwrapResult } from '@reduxjs/toolkit';

export const useOrderAutomatizationModalLoader = (editableOrderIds: number[], selectedOrderIds: number[]) => {
  const dispatch: AppDispatch = useDispatch();
  const isEditing = useSelector(shippingLabelModalSelectors.isEditing);

  const {
    modalWindows: { orderLinkWithProduct },
  } = useLocalization();

  useEffect(() => {
    return () => {
      dispatch(orderAutomatizationActions.resetState());
    };
  }, []);

  const fetchOrdersAutomatization = async (orderIds: number[], isShippingAutomation: boolean) => {
    const result = await dispatch(
      orderAutomatizationAsyncActions.getOrdersAutomatizationRequest({ orderIds, isShippingAutomation }),
    );

    const { orders = [] } = unwrapResult(result);
    return orders;
  };

  const getOrderAutomatizationRows = async (orderIds: number[]) => {
    const orders = await fetchOrdersAutomatization(orderIds, true);
    const packagesEmpty = orders?.some((order) => order.selectedPackages.length === 0);

    if (orders?.length === 0 || packagesEmpty) {
      await fetchOrdersAutomatization(orderIds, false);
      dispatch(shippingLabelModalActions.setShippingLabelStep(ShippingLabelStep.OrderWithoutAutomatizaion));

      return;
    } // if

    if (!isEditing) {
      Toasts.showInfo({
        title: orderLinkWithProduct.Toasts.Title,
        text: orderLinkWithProduct.Toasts.Message,
      });

      dispatch(shippingLabelModalActions.setShippingLabelStep(ShippingLabelStep.OrderLabelPrint));
    }
  };

  useEffect(() => {
    const orderIds = editableOrderIds.length > 0 ? editableOrderIds : selectedOrderIds;

    getOrderAutomatizationRows(orderIds);
  }, [editableOrderIds, selectedOrderIds]);
};
